import { Box, BoxProps, styled } from '@mui/material';

const StyledContentBox = styled(Box)<BoxProps>(({ theme }) => ({
  backgroundColor: theme.palette.main.white,
  borderRadius: theme.spacing(2),
  border: `0.1rem solid ${theme.palette.border.veryLight}`,
}));

export default StyledContentBox;
